module.exports = "<ng-container>\n  <img [src]=\"_iconPath\" class=\"rounded-circle face-icon-bordered face-icon-{{iconSize}}\" alt=\"{{name}}\" (error)=\"setDefaultAvatar()\">\n</ng-container>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/face-icon/face-icon.component.html
// module id = ../../../../../src/app/components/face-icon/face-icon.component.html
// module chunks = main